import { createConsts, createActions } from '../../utils/redux';
import { LOCATION_CHANGE } from '../../utils/redux/location-reducer';

export const consts = createConsts(
  'ui',
  'drawer',
  'TOGGLE_VISIBILITY',
  'MOBILE_VISIBLE',
);
export const actions = createActions(consts);

const initialState = {
  visible: true,
  desktopVisible: true,
  route: null,
};

// show drawer opened on page loading [mobile]
const handleLocationChange = (state, payload) => {
  const { pathname } = payload;
  const route = pathname && pathname.split('/')[1];
  const newState = route !== state.route ? initialState : state;

  return { ...newState, route };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.TOGGLE_VISIBILITY:
      return {
        ...state,
        visible: !state.visible,
      };
    case consts.MOBILE_VISIBLE:
      return {
        ...state,
        visible: true,
      };
    case LOCATION_CHANGE:
      return handleLocationChange(state, action.payload);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/drawer.js